import { UserFormData } from '@/entities/User/User'
import { trans } from '@/helpers/trans'

export interface ValidationErrors {
    employeeNumber?: string
    firstname?: string
    lastname?: string
    email?: string
    phone?: string
    password?: string
    passwordRepeat?: string
    pincode?: string
    pincodeRepeat?: string
}

function validatePassword(password: string): boolean {
    const passwordRegEx = /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,}$/

    if (! password) {
        return false
    }

    return (password.search(passwordRegEx) === 0 && password.length > 7)
}

function validatePincode(pincode: string): boolean {
    if (! pincode) {
        return false
    }

    if (pincode.match(/^[0-9]+$/) === null) {
        return false
    }

    return pincode.length === 4
}

function validatePasswordRepeat(password: string, passwordRepeat?: string): boolean {
    return password === passwordRepeat
}

function validatePincodeRepeat(pincode: string, pincodeRepeat?: string): boolean {
    return pincode === pincodeRepeat
}

function validatePhone(phone: string): boolean {
    return !! (phone && phone.length >= 10)
}


export function validateVerifyRegistrationData(
    formData: UserFormData,
    submitted: boolean,
): ValidationErrors {
    const errors: ValidationErrors = {}

    if (! submitted) {
        return {}
    }

    if (! formData.firstname) {
        errors.firstname = trans('pages.registration.isRequired', {
            item: trans('common.firstName'),
        })
    }

    if (! formData.lastname) {
        errors.lastname = trans('pages.registration.isRequired', {
            item: trans('common.lastName'),
        })
    }

    if (! validatePhone(formData.phone)) {
        errors.phone = trans('pages.registration.phoneNotValid')
    }

    return errors
}

export function validatePasswordRegistrationData(
    formData: UserFormData,
    submitted: boolean,
    isCapsLockPressed?: boolean,
): ValidationErrors {
    const errors: ValidationErrors = {}

    if (isCapsLockPressed) {
        errors.password = formData.password ? trans('pages.registration.capsLockWarning') : undefined
        errors.passwordRepeat = formData.passwordRepeat ? trans('pages.registration.capsLockWarning') : undefined

        return errors
    }

    if (! submitted) {
        return {}
    }

    if (! validatePassword(formData.password)) {
        errors.password = trans('pages.registration.passwordRequirements')
    }

    if (! validatePasswordRepeat(formData.password, formData.passwordRepeat)) {
        errors.passwordRepeat = trans('pages.registration.passwordNotSame')
    }

    return errors
}

export function validatePincodeRegistrationData(
    formData: UserFormData,
    submitted: boolean,
): ValidationErrors {
    const errors: ValidationErrors = {}

    if (! submitted) {
        return {}
    }

    if (! validatePincode(formData.pincode)) {
        errors.pincode = trans('pages.registration.pincodeRequirements')
    }

    if (! validatePincodeRepeat(formData.pincode, formData.pincodeRepeat)) {
        errors.pincodeRepeat = trans('pages.registration.pincodeNotSame')
    }

    return errors
}
